import { Amount } from 'ib/internetbank-core/ib-models/amount';

export interface CreditEarlyRepaymentStatus {
	message: string;
	paymentStatus: CreditEarlyRepaymentStatusPaymentStatus;
	amount?: Amount;
}

export enum CreditEarlyRepaymentStatusPaymentStatus {
	ACTIVE = 'ACTIVE',
	DELAYED = 'DELAYED',
	SUCCESS = 'SUCCESS',
}

export enum CreditEarlyRepaymentPaymentType {
	FULL = 'full',
	PARTIAL = 'partial',
}

export interface CreditEarlyRepaymentPopupData extends CreditEarlyRepaymentStatus {
	paymentType: CreditEarlyRepaymentPaymentType | undefined;
}
